var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _path6, _path7, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFloorTiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e5e5e5;}.cls-2{fill:#e4e7ef;}.cls-3{fill:#914146;}.cls-4{fill:#743438;}.cls-5{fill:#adb5c1;}.cls-6{fill:#ccc;}.cls-7{fill:#c4c4c4;}.cls-8{fill:#5e4146;}.cls-9{fill:#828688;}.cls-10{fill:none;mask:url(#mask);}.cls-11{fill:#fff;fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 69.57,
    y: 15.13,
    width: 4.66,
    height: 4.65,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    className: "cls-11",
    points: "71.28 19.79 69.57 16.84 72.52 15.13 74.23 18.08 71.28 19.79"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m29.28,47.48c2.46-1.03,2.81-.27,5.19-1.47s1.91-2.13,4.29-3.33,2.85-.28,5.22-1.49c2.38-1.21,1.91-2.13,4.3-3.34s2.99-.12,5.27-1.51c.2-.12-1.91-1.26-2.14-1.17-2.46,1.03-2.81.27-5.19,1.47s-1.91,2.13-4.29,3.33-2.85.28-5.22,1.49c-2.38,1.21-1.91,2.13-4.3,3.34s-2.99.12-5.27,1.51c-.2.12,1.91,1.26,2.14,1.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m32.9,49.89c2.46-1.03,2.81-.27,5.19-1.47s1.91-2.13,4.29-3.33,2.85-.28,5.22-1.49,1.91-2.13,4.3-3.34,2.99-.12,5.27-1.51c.2-.12-1.91-1.26-2.14-1.17-2.46,1.03-2.81.27-5.19,1.47s-1.91,2.13-4.29,3.33-2.85.28-5.22,1.49-1.91,2.13-4.3,3.34-2.99.12-5.27,1.51c-.2.12,1.91,1.26,2.14,1.17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m37.73,52.31c2.46-1.03,2.81-.27,5.19-1.47s1.91-2.13,4.29-3.33,2.85-.28,5.22-1.49,1.91-2.13,4.3-3.34,2.99-.12,5.27-1.51c.2-.12-1.91-1.26-2.14-1.17-2.46,1.03-2.81.27-5.19,1.47s-1.91,2.13-4.29,3.33-2.85.28-5.22,1.49-1.91,2.13-4.3,3.34-2.99.12-5.27,1.51c-.2.12,1.91,1.26,2.14,1.17Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m42.56,54.72c2.46-1.03,2.81-.27,5.19-1.47s1.91-2.13,4.29-3.33,2.85-.28,5.22-1.49,1.91-2.13,4.3-3.34,2.99-.12,5.27-1.51c.2-.12-1.91-1.26-2.14-1.17-2.46,1.03-2.81.27-5.19,1.47s-1.91,2.13-4.29,3.33c-2.38,1.21-2.85.28-5.22,1.49s-1.91,2.13-4.3,3.34-2.99.12-5.27,1.51c-.2.12,1.91,1.26,2.14,1.17Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m47.39,57.13c2.46-1.03,2.81-.27,5.19-1.47s1.91-2.13,4.29-3.33,2.85-.28,5.22-1.49,1.91-2.13,4.3-3.34,2.99-.12,5.27-1.51c.2-.12-1.91-1.26-2.14-1.17-2.46,1.03-2.81.27-5.19,1.47s-1.91,2.13-4.29,3.33-2.85.28-5.22,1.49-1.91,2.13-4.3,3.34-2.99.12-5.27,1.51c-.2.12,1.91,1.26,2.14,1.17Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23.79 69.68 0 57.61 23.79 45.54 47.59 57.61 23.79 69.68"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "23.79 69.68 23.79 71.64 0 59.58 0 57.61 23.79 69.68"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "23.79 69.68 23.79 71.64 47.59 59.58 47.59 57.61 23.79 69.68"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "76.21 69.68 100 57.61 76.21 45.54 52.41 57.61 76.21 69.68"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "76.21 69.68 76.21 71.64 52.41 59.58 52.41 57.61 76.21 69.68"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "76.21 69.68 76.21 71.56 100 59.42 100 57.61 76.21 69.68"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "50 82.96 73.79 70.89 50 58.82 26.21 70.89 50 82.96"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "26.21 70.89 26.21 72.87 50 84.93 50 82.96 26.21 70.89"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "73.79 70.89 73.79 72.79 50 84.93 50 82.96 73.79 70.89"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "cls-9",
    points: "78.51 33.25 74.78 44.54 72.33 43.42 72.39 41.76 70.34 40.71 70.21 42.05 67.77 40.97 67.79 39.64 65.87 38.47 65.71 39.7 62.97 38.51 63.17 37.19 61.12 36.15 61.09 37.25 58.66 36.06 58.7 34.89 56.62 33.8 56.42 35 54.44 33.8 58.97 23.13 78.51 33.25"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    className: "cls-1",
    points: "77.97 33.56 74.24 44.85 71.78 43.73 71.85 42.07 69.79 41.02 69.66 42.37 67.23 41.28 67.25 39.96 65.33 38.78 65.17 40.02 62.43 38.83 62.63 37.5 60.58 36.46 60.55 37.56 58.12 36.37 58.16 35.2 56.08 34.11 55.87 35.32 53.89 34.11 58.42 23.45 77.97 33.56"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    className: "cls-3",
    points: "77.97 33.56 76.72 37.54 56.91 27.02 58.42 23.45 77.97 33.56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    className: "cls-3",
    d: "m70.21,17.69l-4.04,10.82s.26.84.97.98c0,0,.83-.1,1.05-.61l5.4-11.52-3.39.33h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    className: "cls-4",
    d: "m71.98,19.11l-4.83,10.38s.9-.11,1.05-.61l5.4-11.56-1.62,1.79h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    className: "cls-8",
    d: "m72.75,18.94c.81-.47,1.09-1.51.62-2.33s-1.51-1.09-2.33-.62-1.09,1.51-.62,2.33,1.51,1.09,2.33.62"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorTiles);
export default __webpack_public_path__ + "static/media/floor-tiles.de284974bdd4e007ace519350573d941.svg";
export { ForwardRef as ReactComponent };